// @flow
import * as React from 'react';
import {Caption} from 'sail/Text';
import Group from 'sail/Group';
import Icon from 'sail/Icon';
import Button from 'sail/Button';
import {next} from 'sail/Icon/Assets';

type SuccessProps = {|
  children: React.Node,
  clickContinue: Function,
|};

export const Success = ({children, clickContinue}: SuccessProps) => {
  return (
    <Group direction="vertical" spacing={8}>
      <Group direction="horizontal" spacing={8} alignItems="center">
        <Icon color="green" icon="checkCircle" />
        <Caption color="green">{children}</Caption>
      </Group>
      <Button
        color="blue"
        label="Continue"
        size="small"
        icon={next}
        iconPosition="right"
        onClick={clickContinue}
      />
    </Group>
  );
};
